import {
  addRequestedTestApiRoute,
} from "../../apiRoutes";

import React, { useState } from "react";
import MakeAPICall from "../../apiCalls/common";
import { useFormik } from "formik";
import * as Yup from "yup";
import Modal from "../../components/modal";
import { connect } from "react-redux";
import Loader from "../../components/loader";
import PropTypes from "prop-types";
import ICTagInputExternalData from "../../components/tagInputExternalData";
import InstaButton from "../../components/button";

const AddRequestedTestForm = props => {
  const [apiCallParams, setApiCallParams] = useState(null);
  // template open close
  // const [templateSelectOpen, setTemplateSelectOpen] = useState(false);
  // const [selectedTemplate, setSelectedTemplate] = useState("");
  // const [saveTemplate, setSaveTemplate] = useState(false);
  // const [openSaveTemplateModal, setOpenSaveTemplateModal] = useState(false);
  // const [pathologyTemplateList, setPathologyTemplateList] = useState([]);
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  // const [showTemplateDeleteModal, setShowTemplateDeleteModal] = useState(false);
  // const [selectedDelTemplate, setSelectedDelTemplate] = useState(null);
  const [currentTagInputText, setCurrentTagInputText] = useState('');

  const [selectedCommonRequest, setSelectedCommonRequest] = useState(
    "Select Common Request"
  );

  // template saved success modal
  // const [showTemplateSuccessModal, setShowTemplateSuccessModal] = useState(
  //   false
  // );
  //
  // const defaultTemplates = [
  //   {
  //     _id: "1",
  //     templateName: "Autoimmune Screen",
  //     note:
  //       "Erythrocyte Sedimentation Rate (ESR), Antinuclear Antibodies (ANA), Rheumatoid Factor (RF), Thyroid Ab, Anti-citrullinated Protein Antibody (ACPA)"
  //   },
  //   {
  //     _id: "2",
  //     templateName: "Cardiovascular Risk Screen",
  //     note:
  //       "Full Blood Count (FBC), Electrolytes/Liver Function Test (E/LFT), Glucose, Lipid Studies & HDL/LDL "
  //   },
  //   {
  //     _id: "3",
  //     templateName: "Diabetic Review Screen",
  //     note:
  //       "Full Blood Count (FBC), Electrolytes/Liver Function Test (E/LFT), Hemoglobin A1C (HbA1c), Lipid Studies & HDL/LDL, Urine Microalbumin"
  //   },
  //   {
  //     _id: "4",
  //     templateName: "General Health Screen",
  //     note:
  //       "Full Blood Count (FBC), Urine Albumin/Creatinine Ratio (ACR), Urea and Electrolytes (UE), C-Reactive Protein (CRP), Thyroid Stimulating Hormone (TSH), Liver Function Test (LFT), Prostate Specific Antigen (PSA), Full Blood Sugar Level (BSL), Lipid Studies & HDL/LDL, Glucose-6-Phosphate Dehydrogenase (G6PD)"
  //   },
  //   {
  //     _id: "5",
  //     templateName: "Hormone Screen",
  //     note:
  //       "Oestrogen E2, Progesterone P4, Dehydroepiandrosterone Sulfate (DHEAS), Free Testosterone"
  //   },
  //   {
  //     _id: "6",
  //     templateName: "Lethargy Screen",
  //     note: "Thyroid Stimulating Hormone (TSH), Glucose, B12/Folate, Ferritin"
  //   },
  //   {
  //     _id: "7",
  //     templateName: "STI Screen",
  //     note:
  //       "Human Immunodeficiency Virus (HIV) Serology, Hepatitis B (HBV) Serology, Hepatitis C (HCV) Serology, Syphilis Serology, Urine Chlamydia PCR, Urine Gonorrhoea PCR, Urine MCS"
  //   }
  // ];
  //
  // const [mergedTemplates, setMergedTemplates] = useState(defaultTemplates);

  const formik = useFormik({
    initialValues: {
      requestedTests: []
    },
    validationSchema: Yup.object({
      requestedTests: Yup.array()
    }),
    onSubmit: values => {
      if (currentTagInputText) {
        const unenteredTest = currentTagInputText.trim()
          .replaceAll(",", "")
          .replaceAll(";", "");
        if (!values.requestedTests) values.requestedTests = [];

        if (!values.requestedTests.includes(unenteredTest)) {
          values.requestedTests.push(unenteredTest);
        }
      }

      values["ticketId"] = props.ticketId;
      setApiCallParams({
        reqType: "POST",
        reqUrl: addRequestedTestApiRoute,
        dataObj: values,
        successCallback: async res => {
          setIsProcessing(false);
          props.onRequestedTestsUpdate(res.data.data.requestedTests);
        },
        failureCallback: err => {
          // setErrModalText(
          //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          // );
          // setShowErrModal(true);
        }
      });
    }
  });

 function noDataToSend(){
  return !(formik.values.requestedTests?.length || !!currentTagInputText)
 }

  // useEffect(() => {
  //   getTemplatesList();
  // }, []);

  // function savePathologyTemplate(dataToSave, callback) {
  //   let formData = new FormData();
  //   formData.append("doctorId", props.auth?.user?._id);
  //   formData.append("templateName", dataToSave.templateName);
  //   formData.append("note", dataToSave.note);
  //
  //   setApiCallParams({
  //     reqType: "POST",
  //     reqUrl: addPathologyRequestTemplateAPI,
  //     dataObj: formData,
  //     successCallback: res => {
  //       setModalText("Template Saved Successfully");
  //       getTemplatesList();
  //       callback();
  //     },
  //     failureCallback: err => {
  //       // setModalText(
  //       //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
  //       // );
  //       // setShowTextModal(true);
  //       callback();
  //     }
  //   });
  // }

  // function getTemplatesList() {
  //   setApiCallParams({
  //     reqType: "GET",
  //     reqUrl: getPathologyRequestTemplateAPI,
  //     params: { doctorId: props.auth?.user?._id },
  //     successCallback: res => {
  //       setPathologyTemplateList(res.data.data);
  //     },
  //     failureCallback: err => {
  //     }
  //   });
  // }

  // function handleSaveTemplateCheckbox(event) {
  //   if (formik.values.requestedTests.length)
  //     setSaveTemplate(event.target.value === "false" ? true : false);
  // }

  // function getReadyToSave(data) {
  //   let dataToSave = {
  //     templateName: data,
  //     note: formik.values.requestedTests.join(", ")
  //   };
  //   savePathologyTemplate(dataToSave, () => {
  //     setOpenSaveTemplateModal(false);
  //     setSaveTemplate(false);
  //     setShowTemplateSuccessModal(true);
  //   });
  // }

  // const deletePathologyRequestTemplate = (id) => {
  //   setShowTemplateDeleteModal(false);
  //
  //   if (selectedDelTemplate !== null) {
  //     let formData = new FormData();
  //     formData.append("templateId", selectedDelTemplate);
  //
  //     setApiCallParams({
  //       reqType: "DELETE",
  //       reqUrl: deletePathologyRequestTemplateAPI,
  //       dataObj: formData,
  //       successCallback: res => {
  //         setModalText("Template Deleted Successfully");
  //         setShowTextModal(true);
  //         setSelectedDelTemplate(null);
  //         getTemplatesList();
  //       },
  //       failureCallback: err => {
  //         // setModalText(
  //         //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
  //         // );
  //         // setShowTextModal(true);
  //         setSelectedDelTemplate(null);
  //       }
  //     });
  //   }
  // };

  // useEffect(() => {
  //   if (saveTemplate === true) setOpenSaveTemplateModal(true);
  //   else setOpenSaveTemplateModal(false);
  // }, [saveTemplate]);

  // useEffect(() => {
  //   if (pathologyTemplateList.length) {
  //     let data = defaultTemplates.concat(pathologyTemplateList);
  //     setMergedTemplates(data);
  //   } else {
  //     setMergedTemplates(defaultTemplates);
  //   }
  // }, [pathologyTemplateList]);

  // function setDeletePathologyRequestTemplateId(templateId) {
  //   setSelectedDelTemplate(templateId);
  //   setTemplateSelectOpen(false);
  //   setShowTemplateDeleteModal(true);
  // }

  // function handleChangeTemplate(event) {
  {/*  setSelectedCommonRequest("Select Common Request");*/}
  {/*  setSelectedTemplate(event.target.value);*/}
  //
  //   formik.setFieldValue(
  //     "requestedTests",
  //     mergedTemplates[event.target.value - 1].note
  //       .split(",")
  //       .map(str => str.trim())
  //   );
  // }

  return (
    <>
      {/*<div className="row w-100 p-0 m-0">*/}
      {/*  <div className="col-sm-12 pl-0 pr-0">*/}
      {/*    {pathologyTemplateList && (*/}
      {/*      <FormControl className="ic-select w-100">*/}
      {/*        <Select*/}
      {/*          value={selectedTemplate}*/}
      {/*          onChange={handleChangeTemplate}*/}
      {/*          displayEmpty*/}
      {/*          className={"placeholder-small"}*/}
      {/*          inputProps={{ "aria-label": "Without label" }}*/}
      {/*          open={templateSelectOpen}*/}
      {/*          onClose={() => {*/}
      {/*            setTemplateSelectOpen(false);*/}
      {/*          }}*/}
      {/*          onOpen={() => {*/}
      {/*            setTemplateSelectOpen(true);*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          <MenuItem value="" disabled>*/}
      {/*            Select Common Request*/}
      {/*          </MenuItem>*/}
      {/*          {mergedTemplates.map((item, index) => (*/}
      {/*            <MenuItem key={item._id} value={index + 1}>*/}
      {/*              <div className="w-100 d-flex flex-row justify-content-between align-items-center">*/}
      {/*                <span>{item.templateName}</span>*/}
      {/*                {selectedTemplate !== index + 1 && index > 6 && (*/}
      {/*                  <button*/}
      {/*                    onClick={e => {*/}
      {/*                      e.preventDefault();*/}
      {/*                      e.stopPropagation();*/}
      {/*                      setTemplateSelectOpen(false);*/}
      {/*                      setDeletePathologyRequestTemplateId(item._id);*/}
      {/*                    }}*/}
      {/*                    type="button"*/}
      {/*                    className="btn btn-out-delete ml-2"*/}
      {/*                  >*/}
      {/*                    <i className="fas fa-trash-alt"></i>*/}
      {/*                  </button>*/}
      {/*                )}*/}
      {/*              </div>*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*</div>*/}

      <div className="col-sm-12 my-3">
        <ICTagInputExternalData
          label="Press Enter to Add Test"
          tags={formik.values.requestedTests}
          placeholder={"Additional Tests Requested"}
          onInputChange={setCurrentTagInputText}
          setTags={val => {
            formik.setFieldValue("requestedTests", val);
          }}
        />
      </div>

      {/*<div className="col-sm-12 custom-chk-lbl save-template-checkbox pl-4 mt-2 text-right">*/}
      {/*  <ICCheckbox*/}
      {/*    style={{ padding: 0, paddingRight: "10px" }}*/}
      {/*    name="saveTemplate"*/}
      {/*    onChange={handleSaveTemplateCheckbox}*/}
      {/*    value={saveTemplate}*/}
      {/*    inputProps={{ "aria-label": "saveTemplate" }}*/}
      {/*    label="Save Template"*/}
      {/*  />*/}
      {/*</div>*/}

      <div className="col-sm-12 row mt-2 align-items-center">
        <div className="m-auto row">
          <InstaButton className={"insta-button-primary mr-2"}
                  onClick={formik.handleSubmit}
                  disabled={noDataToSend()}
          >
            Submit
          </InstaButton>

          <button className="insta-button-primary"
                  onClick={() => props.onRequestedTestsUpdate()}
          >
            Cancel
          </button>
        </div>
      </div>

      <Modal
        useOneButton={true}
        cancelText="Okay"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />

      {/*<Modal*/}
      {/*  openModal={openSaveTemplateModal}*/}
      {/*  title="Add New Template"*/}
      {/*  modalBodyContent={*/}
      {/*    <AddPathologyRequestTemplate*/}
      {/*      cancelEvent={() => {*/}
      {/*        setSaveTemplate(false);*/}
      {/*        setOpenSaveTemplateModal(false);*/}
      {/*      }}*/}
      {/*      onAddSubmit={getReadyToSave}*/}
      {/*    />*/}
      {/*  }*/}
      {/*  noFooterButtons={true}*/}
      {/*/>*/}

      {/*<Modal*/}
      {/*  openModal={showTemplateSuccessModal}*/}
      {/*  modalBodyContent={*/}
      {/*    <p className="text-center mb-0">Template Saved Successfully</p>*/}
      {/*  }*/}
      {/*  okayText="Okay"*/}
      {/*  cancelText="Okay"*/}
      {/*  title=""*/}
      {/*  useOneButton={true}*/}
      {/*  okayEvent={() => {*/}
      {/*    setShowTemplateSuccessModal(false);*/}
      {/*  }}*/}
      {/*  cancelEvent={() => {*/}
      {/*    setShowTemplateSuccessModal(false);*/}
      {/*  }}*/}
      {/*/>*/}

      {/*<Modal*/}
      {/*  openModal={showTemplateDeleteModal}*/}
      {/*  modalBodyContent={*/}
      {/*    <p className="text-center mb-0">*/}
      {/*      Are you sure you want to delete this template?*/}
      {/*    </p>*/}
      {/*  }*/}
      {/*  okayText="Yes"*/}
      {/*  cancelText="No"*/}
      {/*  title="Instant Consult"*/}
      {/*  useOneButton={false}*/}
      {/*  okayEvent={deletePathologyRequestTemplate}*/}
      {/*  cancelEvent={() => {*/}
      {/*    setShowTemplateDeleteModal(false);*/}
      {/*    setSelectedDelTemplate(null);*/}
      {/*  }}*/}
      {/*/>*/}
      {isProcessing && <Loader />}
      <MakeAPICall apiParam={apiCallParams} />
    </>
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

AddRequestedTestForm.propTypes = {
  onRequestedTestsUpdate: PropTypes.func.isRequired,
  ticketId: PropTypes.string.isRequired
};

export default connect(
  mapStateToProps
)(AddRequestedTestForm);


